export default [{
  path: '/login',
  component: resolve => import(/* webpackChunkName: "entry" */ '../Index.vue').then(resolve),
  meta: {
    title: '登录',
    hideNav: true
  }
}]
